
import 'jquery-ui/themes/base/all.css';
import 'jquery-ui/ui/widgets/autocomplete.js';
import 'jquery-ui/ui/widgets/sortable.js';
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./font-awesome');
require('./calendar');

import 'bootstrap-modal/index.js';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';

$(document).ready(function () {
    $('[data-toggle="tooltip"]').tooltip();  
    $('.datepicker').datepicker({
            format: 'yyyy-mm-dd',
            uiLibrary: 'bootstrap5'
        });
});
